
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in-or-register",
      function () {
        return require("private-next-pages/sign-in-or-register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-in-or-register"])
      });
    }
  